// extracted by mini-css-extract-plugin
module.exports = {"container":"_38_Yb","dot":"XsQG0","activeDot":"_33_3I","isWhiteActiveDot":"_3HGlp"};